/**
 * AjaxRequest
 * Felix Kiesewetter <info@felixkiesewetter.de>
 * v1.2.0
 * 2021-06-17
 */
export default class AjaxRequest
{

    constructor(options)
    {

        if ('undefined' === typeof options.url) {
            console.error('AjaxRequest requires a url');
            return;
        }

        const url = options.url;
        const absolute = options.absolute || false;
        const data = options.data || null;
        const callback = 'function' === typeof options.callback ? options.callback : null;
        const method = options.method || 'POST';
        const contentType = options.contentType || this.CONTENT_TYPE_JSON;

        let debugContainer = document.getElementById('ajax-request-debugger');
        if (!debugContainer) {
            debugContainer = document.createElement('aside');
            debugContainer.id = 'ajax-request-debugger';
            debugContainer.style.position = 'fixed';
            debugContainer.style.top = '15px';
            debugContainer.style.left = '15px';
            debugContainer.style.right = '15px';
            debugContainer.style.maxHeight = '200px';
            debugContainer.style.zIndex = '1000';
            debugContainer.style.overflowX = 'scroll';
            debugContainer.style.display = 'none';
            document.body.append(debugContainer);
        }

        let awaitReadyStatus = null;
        let isReady = false;
        let status = null;
        let response = null;

        this.send = () => {
            window.dispatchEvent(new CustomEvent('ajaxRequestSend'));
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4) {
                    isReady = true;
                    status = this.status;
                    if (this.status === 200) {
                        // TODO: Stuff only after success
                        debugContainer.innerHTML = '';
                        debugContainer.style.display = 'none';
                    }
                    else {
                        console.error('AjaxRequest failed!');
                        console.error(this);
                        debugContainer.innerHTML = this.responseText;
                        debugContainer.style.display = 'block';
                    }
                    response = contentType === AjaxRequest.CONTENT_TYPE_JSON ? JSON.parse(this.responseText) : this.responseText;
                    if (callback) {
                        callback(response);
                    }
                    window.dispatchEvent(new CustomEvent('ajaxRequestComplete'));
                }
            };
            xhttp.open(method, this.getAbsoluteOrRelativeUrl(url, absolute), true);
            xhttp.setRequestHeader("Content-type",'application/x-www-form-urlencoded');
            this.urlEncodedData = this.urlEncodeData();
            xhttp.send(this.urlEncodedData);
        };

        this.urlEncodeData = () => {
            let urlEncodedDataPairs = [];
            for (const name in data) {
                let value = data[name];
                if ('object' === typeof value) {
                    value = JSON.stringify(value);
                }
                urlEncodedDataPairs.push(`${encodeURIComponent(name)}=${encodeURIComponent(value)}`);
            }
            return urlEncodedDataPairs.join('&');
        };

        this.getResponse = () => {
            awaitReadyStatus = setInterval(() => {
                console.log(isReady);
                if (isReady) {
                    clearInterval(awaitReadyStatus);
                    return response;
                }
            }, 50);
        };

        this.getPublicRequestUrl = () => {
            return `${this.getAbsoluteOrRelativeUrl(url, true)}?${this.urlEncodedData}`;
        };

    }

    getAbsoluteOrRelativeUrl(url, absolute)
    {
        if (!document.baseURI) {
            return;
        }
        const absoluteBaseUrl = document.baseURI;
        if (absolute) {
            if (!(new RegExp(absoluteBaseUrl).test(url))) {
                return `${absoluteBaseUrl}${url.replace(/^\/+/, '')}`;
            }
            return url;
        }
        const relativeBaseUrl = absoluteBaseUrl.replace(window.location.origin, '');
        if (!(new RegExp(relativeBaseUrl).test(url))) {
            return `${relativeBaseUrl}${url.replace(/^\/+/, '')}`;
        }
        return url;
    }

}

Object.defineProperty(AjaxRequest, 'CONTENT_TYPE_JSON', {
    value: 'application/json',
    writable : false,
    enumerable : true,
    configurable : false
});

Object.defineProperty(AjaxRequest, 'CONTENT_TYPE_HTML', {
    value: 'text/html',
    writable : false,
    enumerable : true,
    configurable : false
});

Object.defineProperty(AjaxRequest, 'CONTENT_TYPE_XML', {
    value: 'application/xml',
    writable : false,
    enumerable : true,
    configurable : false
});